import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../../registration.service';
import { HandleError } from '../../../shared/HandleError';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rank-level-form',
  templateUrl: './rank-level-form.component.html',
  styleUrls: ['./rank-level-form.component.css']
})
export class RankLevelFormComponent implements OnInit {
  maintitle="Rank Levels";
  title = "Add Rank Levels";
  s: any = {};
  c: any = {};
  data: any;
  ServiceTypes: any=[];
  ServiceCategories: any=[];
  Ranks: any=[];
  formInvalid: boolean = false;
  mode:string="save";
  RL_Id: string;
  formSubmitted: boolean;
  constructor(private service: RegistrationService,private handleError:HandleError,private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.GetAllServiceTypes();
    this.GetAllServiceCategories();
    this.GetAllRanks();


    //From URL
  this.mode=localStorage.getItem('mode');
  this.RL_Id= localStorage.getItem('RL_Id');
  localStorage.removeItem('RL_Id'); 
  localStorage.removeItem('mode');
  
  if (this.RL_Id != null && this.mode!=null) 
    this.GetRankLevelById(this.RL_Id);
  }
  


//Service type dropdown
  GetAllServiceTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllServiceTypes();
    this.data.subscribe(
      (response) => {
        this.ServiceTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  
  
//Service category dropdown
  GetAllServiceCategories() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllServiceCategories();
    this.data.subscribe(
      (response) => {
        this.ServiceCategories = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllRanks() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllRanks();
    this.data.subscribe(
      (response) => {
        this.Ranks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //console.log(error);
      });
  }



   //Save
   SaveRankLevel(ranklevel: NgForm) {    
    
   // alert(this.s.SR_PA_Pincode.getRawValue());
     if (ranklevel.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.saveRankLevels(ranklevel.value);
      this.data.subscribe(
        (response) => {
          ranklevel.reset();
          ranklevel.resetForm();       
          swal('Success!', 'Rank Level saved Successfully .', 'success');
          this.router.navigate(['/home/RankLevels']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.handleError.ErrorHandler(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  GetRankLevelById(RL_Id) {
       document.getElementById('loader-spinner').style.display = "block";
      this.service.getRankLevelById(RL_Id)
      .subscribe(
        (data) => {
          this.s = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
  }



  UpdateRankLevel(ranklevel: NgForm) {
    if (!ranklevel.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    this.service.updateRankLevel(ranklevel.value,this.RL_Id)
      .subscribe(
        (data) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Updated Successfully!','success');
          this.router.navigate(['/home/RankLevels']); 
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
          //swal('Warning!', error.error.Message, 'warning');
        });
      }else{
        document.getElementById('loader-spinner').style.display = "none";
        swal('warning','Please fill all the mandatory fields!','warning');
        this.formSubmitted = true;

        }
  }



}



// WEBPACK FOOTER //
// ./src/app/masters/rank-levels/rank-level-form/rank-level-form.component.ts